import Controller from "@ember/controller";

export default class GroupManageProfileController extends Controller {
  /** @type {boolean | null} */
  saving = null;
}
